import React, { useEffect, useState } from "react";
import { Table, Button, Pagination } from "rsuite";

import "../styles/EditRecord.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance";

const { Column, HeaderCell, Cell } = Table;

export default function EditRecord() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };

  const finalData = data.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  async function getInfo() {
    const result = await axiosInstance.get("/api/get-records");
    const numbers = result.data;
    setData(numbers);
  }

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div className="edit-record-table">
      <h2 className="heading">Edit Records</h2>
      <Table
        virtualized
        height={300}
        data={finalData}
        autoHeight={true}
        affixHeader
        affixHorizontalScrollbar
        rowHeight={40}
        headerHeight={30}
        onRowClick={(rowData) => {}}
      >
        <Column width={150} align="center" fixed>
          <HeaderCell>Reference Number</HeaderCell>
          <Cell dataKey="reference_number" />
        </Column>
        <Column width={150} resizable>
          <HeaderCell>Date</HeaderCell>
          <Cell dataKey="date" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>Issue Voucher</HeaderCell>
          <Cell dataKey="issue_voucher" />
        </Column>

        <Column width={100} resizable>
          <HeaderCell>Name</HeaderCell>
          <Cell dataKey="name" />
        </Column>

        <Column width={100} resizable>
          <HeaderCell>Sex</HeaderCell>
          <Cell dataKey="sex" />
        </Column>

        <Column width={180} resizable>
          <HeaderCell>Age</HeaderCell>
          <Cell dataKey="age" />
        </Column>

        <Column width={100} resizable>
          <HeaderCell>Weight</HeaderCell>
          <Cell dataKey="weight" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>Health Condition</HeaderCell>
          <Cell dataKey="health_condition" />
        </Column>
        <Column width={80} resizable>
          <HeaderCell>Parasites</HeaderCell>
          <Cell dataKey="parasites" />
        </Column>
        <Column width={300} resizable>
          <HeaderCell>Receiving Details</HeaderCell>
          <Cell dataKey="receiving_details" />
        </Column>
        <Column width={300} resizable>
          <HeaderCell>Marks</HeaderCell>
          <Cell dataKey="marks" />
        </Column>
        <Column width={150} resizable>
          <HeaderCell>Area</HeaderCell>
          <Cell dataKey="area" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Captivity Time</HeaderCell>
          <Cell dataKey="captivity_time" />
        </Column>
        <Column width={150} resizable>
          <HeaderCell>Mode of Transport</HeaderCell>
          <Cell dataKey="mode_of_transport" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Authoritative Contact</HeaderCell>
          <Cell dataKey="authoritative_contact" />
        </Column>
        <Column width={50} resizable>
          <HeaderCell>Criminal Case</HeaderCell>
          <Cell dataKey="criminal_case" />
        </Column>
        <Column width={160} fixed="right">
          <HeaderCell>...</HeaderCell>
          <Cell style={{ padding: "6px" }}>
            {(rowData) => (
              <div>
                <Button
                  appearance="link"
                  onClick={() => navigate(`/record/edit/${rowData.id}`)}
                >
                  Edit
                </Button>
                <Button
                  appearance="link"
                  onClick={() => {
                    alert(`reference_number:${rowData.reference_number}`);
                    const result = axiosInstance.post("/api/delete-record", {
                      reference_number: rowData.reference_number,
                    });
                  }}
                >
                  Delete
                </Button>
              </div>
            )}
          </Cell>
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={data.length}
          limitOptions={[20, 40, 80, 160, 300]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </div>
  );
}
